import APIV5 from '~/models/api';

/* globals Search */

export default class SearchFactory {
	#$rootScope;

	#$timeout;

	#$q;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.#$rootScope = $injector.get('$rootScope');
		this.#$timeout = $injector.get('$timeout');
		this.#$q = $injector.get('$q');

		/** @type {any} */
		this.defaultSearch = undefined;

		/** @type {any[]} */
		this.suggestedFilters = [];

		/** @type {any[]} */
		this.suggestedTypes = [];

		/** @type {Search.Item | undefined} */
		this.type = undefined;

		/** @type {?boolean} */
		this.enabled = true;

		/** @type {any} */
		this.filters = [];

		this.clear();
	}

	/**
	 * Launch the API Extract
	 *
	 * @param {number} [packetIndex] Packet index
	 * @param {number} [packetSize] Packet size
	 * @returns {Promise<import('@knitiv/api-client-javascript').ExtractOutput|void>} Promise
	 */
	async extract(packetIndex, packetSize) {
		if (!this.type?.kid) {
			return this.#$q.resolve();
		}

		for (const filter of this.filters) {
			const f = filter;
			if ('node' in f) {
				f.kid = f.node;
				delete f.node;
			}
		}

		return this.#$q.when(
			APIV5.instance.extract({
				extract: {
					enabled: this.enabled === null ? undefined : this.enabled,
					filter: this.getFilters(),
					search_kid: this.type.kid,
				},
				packet_index: packetIndex ?? 1,
				packet_size: packetSize ?? 50,
			}, { id: 'search-factory.extract', endpointVersion: 3 }),
		);
	}

	/**
	 * Launch the API Extract
	 *
	 * @param {string} format Export format
	 * @param {import('@knitiv/api-client-javascript').KNode[]} [kids] Optional list of kid to export (selection)
	 * @returns {string} url the download URL
	 */
	extractExport(format, kids) {
		if (!this.type?.kid) {
			throw new Error('No kid specified');
		}

		for (const filter of this.filters) {
			const f = filter;
			if ('node' in f) {
				f.kid = f.node;
				delete f.node;
			}
		}

		/** @type {any} */
		const extract = {
			enabled: this.enabled === null ? undefined : this.enabled,
			filter: this.filters,
			search_kid: this.type.kid,
		};

		// When a selection is provided, restrict the export to those kid
		if (Array.isArray(kids) && kids.length > 0) {
			extract.kids = kids;
		}

		return APIV5.instance.extractToFile({
			extract,
			export: format,
		});
	}

	/**
	 * Returns the filters selected by the user
	 *
	 * @returns {{
	 *   isa: import('@knitiv/api-client-javascript').KNode,
	 *   kid: import('@knitiv/api-client-javascript').KNode
	 * }[]} Filters array
	 */
	getFilters() {
		return this.filters.map((/** @type {any} */ filter) => ({
			isa: filter.isa,
			kid: filter.kid,
		}));
	}

	/**
	 * Set the search from kid
	 *
	 * @async
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @param {Array<*>} [providedFilters]
	 * @returns {Promise<any>}
	 */
	setFromKid(kid, providedFilters) {
		// @ts-ignore
		return this.#$q
			.all([
				APIV5.instance.objectInfo({ kid }, { id: 'search-set-from-kid' }),
				APIV5.instance.searchFilters({ nodeid: kid }, { id: 'search-set-from-kid' }),
			])
			.then((/** @type {any} */ [object, filters]) => ({
				kid: object.objid,
				isa: object.isa.objid,
				lang: object.lang,
				name: object.objname,
				filters: filters.result,
			}))
			// @ts-ignore
			.then((/** @type {Search.Item} */ myItem) => this.setItem(myItem, providedFilters));
	}

	clear() {
		this.reset();

		this.suggestedFilters.length = 0;
		this.suggestedTypes.length = 0;

		this.defaultSearch = {
			mf_order: '',
		};
	}

	/**
	 * Reset filter and type of document
	 */
	reset() {
		this.enabled = true;
		this.type = undefined;
		this.filters.length = 0;
		// this.#$timeout(() => {
		// 	this.#$rootScope.$broadcast('Search.onSetFilters', this.type, this.filters);
		// });
	}

	/**
	 * Set typedoc and filters
	 *
	 * @param {Search.Item} typedoc Document type
	 * @param {Array<*>} [filters] Filters array
	 * @returns {*} result
	 */
	setItem(typedoc, filters = []) {
		if (this.type === undefined) {
			this.type = {
				kid: typedoc.kid,
				name: typedoc.name,
			};
		}
		else {
			this.type.kid = typedoc.kid;
			this.type.name = typedoc.name;
		}
		if (filters?.length > 0) {
			this.setFilters(filters);
		}
	}

	getItem() {
		return this.type;
	}

	/**
	 * Set filters
	 *
	 * @param {Array<*>} filters Filters array
	 */
	setFilters(filters) {
		if (Array.isArray(filters)) {
			this.filters = filters;
			this.#$timeout(() => {
				this.#$rootScope.$broadcast('Search.onSetFilters', this.type, this.filters);
			});
		}
	}
}
